import { render, staticRenderFns } from "./newCommon.vue?vue&type=template&id=11473c14&scoped=true"
import script from "./newCommon.vue?vue&type=script&lang=js"
export * from "./newCommon.vue?vue&type=script&lang=js"
import style0 from "./newCommon.vue?vue&type=style&index=0&id=11473c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11473c14",
  null
  
)

export default component.exports